<template>
  <section>
    <div
      class="w-full antialiased transition-all duration-300 ease-in-out top-0"
      :class="
        transparent
          ? 'bg-transparent z-50'
          : fixed
          ? 'bg-white fixed z-[60]'
          : 'hidden'
      "
      :id="!transparent ? 'menu' : 'menu-fixed'"
    >
      <nav class="relative z-50 select-none">
        <AnnouncementBanner :stylesType="transparent" v-if="transparent" />
        <div
          id="header"
          class="h-16 xl:h-24 relative w-full flex flex-wrap items-center justify-between overflow-hidden font-medium xl:overflow-visible xl:justify-center px-4 md:px-8 xl:px-14 bg-white z-50 shadow-md"
          :class="transparent ? '' : '  shadow-md'"
        >
          <div class="flex items-center justify-start sm:w-1/4 h-full pr-4">
            <inertia-link
              :href="$route('home')"
              class="inline-block py-4 xl:py-0"
              aria-label="Home"
              @click="handleNavClick"
            >
              <img src="/storage/images/logo.svg" alt="Youverse" class="w-32" />
            </inertia-link>
          </div>
          <div
            class="top-0 left-0 items-start w-full h-full text-sm bg-gray-900 bg-opacity-50 xl:items-center xl:w-3/4 xl:text-base xl:bg-transparent xl:p-0 justify-end"
            :class="{
              'fixed flex': $store.state.showSideMenu,
              'hidden xl:flex': !$store.state.showSideMenu,
            }"
          >
            <div
              id="mobile-menu"
              class="flex-col w-2/3 max-w-md xl:max-w-full xl:w-full bg-white rounded-l-lg px-6 pt-6 pb-12 xl:p-0 xl:px-0 xl:pb-0 xl:bg-transparent xl:overflow-visible xl:rounded-none xl:flex xl:flex-row items-center justify-center h-full overflow-y-auto"
            >
              <div class="flex justify-between items-center">
                <div
                  class="inline-flex items-center w-auto h-16 xl:px-6 text-xl font-black leading-none text-gray-900 xl:hidden"
                >
                  <img
                    src="/storage/images/logo.svg"
                    alt="Youverse"
                    class="w-28"
                  />
                </div>
                <div
                  @click="toggleSideMenu(false)"
                  class="w-10 h-10 z-10 inline-flex justify-center items-center bg-gray-50 rounded-full cursor-pointer xl:hidden hover:bg-gray-200"
                  v-if="$store.state.showSideMenu"
                >
                  <font-awesome-icon
                    class="text-primary-color"
                    icon="times"
                    size="xl"
                  />
                </div>
              </div>
              <div
                class="flex flex-col items-start sm:items-center justify-center w-full text-center xl:w-2/3 xl:flex-row xl:items-center xl:mt-0 group"
              >
                <template v-for="(menu, index) in menus">
                  <inertia-link
                    :key="menu.id"
                    v-if="!menu.subMenus && menu.target !== '_blank'"
                    :href="
                      menu.route && $route().has(menu.route)
                        ? $route(menu.route)
                        : menu.url
                    "
                    :target="menu.target"
                    rel="noreferrer"
                    class="relative flex items-center justify-between xl:justify-center space-x-1 text-md font-medium text-gray-dark cursor-pointer py-5 xl:py-[34px] pl-2 pr-5 w-full h-full border-b-2 hover:border-primary-color xl:border-white xl:hover:border-primary-color hover:text-primary-850"
                    :class="[
                      checkCurrentPage(menu)
                        ? 'text-primary-color'
                        : hoveredMenuIndex === index
                        ? 'text-primary-color '
                        : activeHover
                        ? 'text-gray-light'
                        : 'text-gray-dark',
                      'hover:text-primary-color ',
                    ]"
                    @mouseenter="() => setHoveredMenu(index)"
                    @mouseleave="clearHoveredMenu"
                  >
                    {{ menu.title }}
                    <svg
                      class="w-4 h-4 transition-transform duration-200 xl:hidden -rotate-90 text-gray-dark"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </inertia-link>

                  <subMenu
                    :key="index"
                    v-if="menu.subMenus"
                    :menus="menu"
                    :transparent="transparent"
                    :isOpen="openIndex === index"
                    @toggle="toggle(index)"
                    @hoverStart="setHoveredMenu(index)"
                    @hoverEnd="clearHoveredMenu"
                    :hovered="hoveredMenuIndex === index"
                    :activeHover="hoveredMenuIndex !== null"
                    @activeMenu="setActiveMenu"
                    :isActive="activeMenuId === menu.id"
                  ></subMenu>
                </template>
              </div>
              <div
                class="flex flex-col items-start justify-end w-full pt-4 xl:items-center xl:w-1/3 xl:flex-row xl:py-0"
              >
                <div
                  v-if="!$page.props.auth.user"
                  class="xl:w-auto w-full flex justify-center gap-5 xl:mt-0 flex-col xl:flex-row items-center"
                >
                  <div
                    class="w-full font-bold text-gray-900 justify-center text-center xl:hidden block mt-5"
                  >
                    Already have an account?
                    <inertia-link
                      :href="$route('login')"
                      class="text-primary-color font-bold text-base flex justify-center mt-1"
                      @click="handleNavClick"
                    >
                    </inertia-link>
                  </div>

                  <inertia-link
                    :href="$route('login')"
                    class="btn-no-color !py-1 !min-h-fit w-full min-w-28 max-w-60"
                    @click="handleNavClick"
                  >
                    Sign In
                  </inertia-link>
                  <inertia-link
                    v-if="!hideSignUp"
                    :href="$route('register')"
                    class="w-full min-w-28 max-w-60 btn-primary !py-1 !min-h-fit whitespace-nowrap"
                    @click="handleNavClick"
                  >
                    Sign Up
                  </inertia-link>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!$store.state.showSideMenu"
            @click="toggleSideMenu(true)"
            class="absolute right-0 z-10 flex flex-col items-center justify-center w-10 h-10 bg-gray-50 rounded-full cursor-pointer xl:hidden hover:bg-gray-200"
            :class="$page.props.auth.user ? 'mr-16' : 'mr-4'"
          >
            <font-awesome-icon
              class="w-6 h-6 text-primary-850"
              icon="bars"
              size="lg"
            />
          </div>
          <div
            v-if="$page.props.auth.user && !$store.state.showSideMenu"
            class="absolute right-0 xl:mr-12 mr-4 z-10"
          >
            <button
              @click="
                isUserMenuOpen = !isUserMenuOpen;
                heightAnnouncementBanner();
              "
              v-click-outside="hide"
              class="w-10 h-10 focus:outline-none transition duration-150 ease-in-out rounded-full"
              :class="
                transparent
                  ? 'bg-gray-50 hover:bg-gray-200 text-gray-700'
                  : 'bg-gray-700 hover:bg-gray-900 text-gray-100'
              "
              aria-label="User-Button"
            >
              <font-awesome-icon icon="user" size="lg" />
            </button>
          </div>
        </div>
      </nav>
    </div>

    <div
      v-if="$page.props.auth.user"
      v-show="isUserMenuOpen"
      class="fixed top-0 right-0 w-56 mt-16 mr-4 xl:mr-12 origin-top-right transition-all transform rounded-xl z-50"
      :style="'margin-top:' + this.userMenuHeight + 'px'"
      ref="iconMenu"
    >
      <div
        class="bg-white border border-white shadow-md rounded-xl"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <inertia-link
          :href="$route('dashboard')"
          class="block px-4 py-3 text-gray-700 hover:text-gray-800"
        >
          <span class="block text-sm font-medium leading-tight truncate">
            {{ $page.props.auth.user.name }}
          </span>
          <span class="text-xs leading-5 text-gray-600 block truncate">
            {{ $page.props.auth.user.email }}
          </span>
        </inertia-link>

        <div class="border-t border-gray-200 xl:border-white"></div>
        <div class="py-1">
          <a
            v-if="$page.props.auth.user.isAdmin"
            href="/admin"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >
            Admin
          </a>
          <inertia-link
            :href="$route('dashboard')"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >
            Dashboard
          </inertia-link>
          <inertia-link
            :href="$route('user.accountSettings')"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >
            Settings
          </inertia-link>
        </div>
        <div class="border-t border-gray-100"></div>
        <div class="pt-1 pb-2">
          <div
            @click="logout"
            class="cursor-pointer block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 hover:text-primary-color hover:bg-red-50 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
          >
            Sign out
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import subMenu from "./subMenu.vue";
import ClickOutside from "vue-click-outside";
import AnnouncementBanner from "./AnnouncementBanner.vue";

export default {
  components: {
    subMenu,
    AnnouncementBanner,
  },
  directives: {
    ClickOutside,
  },
  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: true,
      menus: [],
      isUserMenuOpen: false,
      hideSignUp: window.disableRegister,
      openMenu: null,
      openIndex: null,
      userMenuHeight: 0,
      hoveredMenuIndex: null,
      activeMenuId: null,
      activeHover: false,
    };
  },
  created() {
    this.menus = this.$page.props?.menus || [];
    this.$store.commit("setShowSideMenu", false);
  },
  mounted() {
    this.popupItem = this.$refs.iconMenu;
    if (!this.transparent) {
      document.onreadystatechange = () => {
        if (document.readyState === "complete") {
          this.hideMenuWhenScrollDown();
        }
      };
    }
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.closeUserMenu);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.closeUserMenu);
  },

  methods: {
    closeUserMenu() {
      this.isUserMenuOpen = false;
    },
    logout() {
      this.axios.post("/logout").then(() => {
        window.location.href = "/";
      });
    },
    hide() {
      if (this.isUserMenuOpen) this.isUserMenuOpen = false;
    },
    checkCurrentPage(menu) {
      if (!menu.route && !menu.subMenus) {
        return false;
      }

      const currentRoute = route().current().toLowerCase();

      const routeMatch =
        menu.route && currentRoute.includes(menu.route.toLowerCase());

      const subMenuMatch = menu.subMenus?.some(
        (sub) => sub.route && currentRoute.includes(sub.route.toLowerCase())
      );

      return (
        routeMatch ||
        currentRoute.includes(menu.title.toLowerCase()) ||
        subMenuMatch
      );
    },
    heightAnnouncementBanner() {
      const menu = this.transparent
        ? document.getElementById("menu-fixed")
        : document.getElementById("menu");
      this.userMenuHeight = menu ? menu.clientHeight + 1 : 0;
    },
    hideMenuWhenScrollDown() {
      let lastScrollTop = 9999999999;
      if (window.innerHeight <= 700) {
        window.addEventListener("scroll", function () {
          var scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          let navbar = document.getElementById("menu");
          if (!navbar) return;
          let top = -navbar.clientHeight - 2;
          if (scrollTop > lastScrollTop) {
            navbar.style.top = top + "px";
          } else {
            navbar.style.top = "0";
          }
          lastScrollTop = scrollTop;
        });
      }
    },
    toggleSideMenu(open) {
      this.$store.commit("setShowSideMenu", open);
    },
    handleNavClick() {
      if (window.innerWidth < 1280) {
        this.$store.commit("setShowSideMenu", false);
      }
    },
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    handleResize() {
      if (window.innerWidth >= 1280) {
        this.$store.commit("setShowSideMenu", false);
      }
    },
    setHoveredMenu(index) {
      this.hoveredMenuIndex = index;
      this.activeHover = true;
    },
    clearHoveredMenu() {
      this.hoveredMenuIndex = null;
      this.activeHover = false;
    },
    getMenuColor(index) {
      if (this.hoveredMenuIndex === null) {
        return "text-gray-dark ";
      } else {
        return this.hoveredMenuIndex === index ? "text-primary-color" : "";
      }
    },
    setActiveMenu(id) {
      this.activeMenuId = id;
    },
  },
};
</script>
